<!-- 下拉选择器 -->
<template>
  <el-select
    v-model="selectedData"
    v-bind="{...$attrs}"
    v-on="$listeners"
    ref="select"
    :disabled="disabled"
    :placeholder="placeholder"
    :multiple="multiple"
    @change="selectChange"
  >
    <el-option
      v-for="item in optionsFilter"
      :key="item.codeItemId"
      :label="item.itemName"
      :value="item[keyProp]">
    </el-option>
  </el-select>
</template>

<script>
  import { deepCopy } from "@/util/util";
  import { validatenull } from "@/util/validate";
  import { mapGetters } from "vuex";
  
  export default {
    name: "bsp-dicts-select",
    props: {
      // 当前下拉选的值
      selectValue: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      // 代码集setId
      dicNum: {
        type: String,
        default: ""
      },
      // 要移除的 itemId,隔开多个
      remNum: {
        type: String,
        default: ""
      },
      // 输入框占位符
      placeholder: {
        type: String,
        required: false,
        default: "请选择"
      },
      // 下拉选数据
      optionsList: {
        type: Array,
        default: () => (
          []
        )
      },
      changeE:{
        type: String,
        default: ""
      },
      keyProp: {
        type: String,
        default: 'codeItemId'
      }
    },
    data() {
      return {
        // 下拉选数据
        options: [],
        selectedData: [],
        isInit: true
      };
    },
    computed: {
      ...mapGetters([
        "dicts"
      ]),
      lang() {
        return localStorage.getItem('lang');
      },
      optionsFilter() {
        const options = JSON.parse(JSON.stringify(this.options));
        options.forEach(item => {
          item.itemName = this.lang == 'en' ? (!validatenull(item.codeItemEnName) ? item.codeItemEnName : item.codeItemName) : item.codeItemName
        })
        return options;
      }
    },
    watch: {
      selectValue(val){
        this.dataFormat(val);
      },
      // 监听传过来的数据list
      optionsList(vaList){
        this.initData();
      },
      dicNum(val) {
        if (val && !this.isInit) {
          this.initData();
        }
      },
      showNum(val) {
        if (!this.isInit) {
          this.initData();
        }
      }
    },
    created() {
      this.initData();
      this.isInit = false;
    },
    mounted() {
    
    },
    methods: {
      initData() {
        //  从后台获取的dicts
        if (this.optionsList.length > 0) {
          //对list进行处理
          this.handleDictc(this.optionsList, this.remNum);
        } else if (this.dicNum) {
          // let storeOption = this.dicts.codeList.hasOwnProperty(this.dicNum)
          // 不是从后台获取的dicts
          let storeOptionList = this.dicts.codeList[this.dicNum];
          //对list进行处理
          this.handleDictc(storeOptionList, this.remNum);
        }
      },
      //  预处理下拉选的list
      handleDictc(list, remNum) {
        let remNumArrary = [];
        let listInnit = deepCopy(list);
        if (remNum) {
          remNumArrary = remNum.split(",");
          for (let i = 0; i < remNumArrary.length; i++) {
            for (let j = 0; j < listInnit.length; j++) {
              let index = listInnit[j]["codeItemId"] == remNumArrary[i];
              if (index) {
                listInnit.splice(j, 1);
              }
            }
          }
          this.options = listInnit;
        } else {
          this.options = list;
        }
        this.dataFormat(this.selectValue)
      },
      dataFormat(val) {
        if(!val){
          this.selectedData = '';
          return ;
        }
        if(this.options){
          for (let i = 0; i < this.options.length; i++) {
            let item = this.options[i];
            item.itemName = this.lang == 'en' ? (!validatenull(item.codeItemEnName) ? item.codeItemEnName : item.codeItemName) : item.codeItemName;
            if (this.options[i].codeItemId === ''+ val) {
              this.selectedData = item.itemName;
            }
          }
        }
      },
      selectChange(val) {
        this.$emit("update:selectValue", val);
        this.$emit("selectChange", this.selectedData);
      },
    }
  };
</script>

<style scoped>
  .el-input.el-input--suffix {
    cursor: pointer;
    overflow: hidden;
  }
  
  .el-input.el-input--suffix.rotate .el-input__suffix {
    transform: rotate(180deg);
  }
  
  .select-tree {
    max-height: 350px;
    overflow-y: scroll;
  }
  
  /* 菜单滚动条 */
  .select-tree::-webkit-scrollbar {
    z-index: 11;
    width: 6px;
  }
  
  .select-tree::-webkit-scrollbar-track,
  .select-tree::-webkit-scrollbar-corner {
    background: #fff;
  }
  
  .select-tree::-webkit-scrollbar-thumb {
    border-radius: 5px;
    width: 6px;
    background: #b4bccc;
  }
  
  .select-tree::-webkit-scrollbar-track-piece {
    background: #fff;
    width: 6px;
  }
  
  .el-form-item__content {
    height: 28px;
  }
</style>
